import { type BoxSaleInput, canPutOnSale, type useSetBoxOnSale } from "./boxSale";

/**
 * A box's "Sell in store" switch: on while the box is listed. Off, it turns on only once the
 * box's rules have built it, and says so to a screen reader. Every switch waits while one change
 * is in flight.
 */
export function SellInStoreSwitch({
  box,
  setOnSale,
}: {
  box: BoxSaleInput & { id: string; name: string; shopify: unknown };
  setOnSale: ReturnType<typeof useSetBoxOnSale>;
}) {
  const listed = Boolean(box.shopify);
  const sellable = canPutOnSale(box);
  return (
    <s-switch
      label={
        sellable || listed
          ? `Sell ${box.name} in your store`
          : `Sell ${box.name} in your store (change its rules until it can be built first)`
      }
      labelAccessibilityVisibility="exclusive"
      checked={listed || undefined}
      disabled={setOnSale.isPending || (!listed && !sellable) || undefined}
      onChange={() => setOnSale.mutate({ boxId: box.id, enabled: !listed })}
    />
  );
}
